import React from 'react';
import { useAuth } from '../context/AuthContext';
import './AuthNotification.css';

const AuthNotification = () => {
  const { authNotification, showNotification } = useAuth();

  if (!authNotification) return null;

  const { message, type = 'info' } = authNotification;
  const className = `auth-notification auth-notification-${type}`;

  const handleDismiss = () => {
    showNotification(null);
  };

  return (
    <div className={className} role="alert" aria-live="assertive">
      {message}
      <button
        className="auth-notification-dismiss"
        onClick={handleDismiss}
        aria-label="Dismiss notification"
      >
        ×
      </button>
    </div>
  );
};

export default AuthNotification;